import { isLocalTarget, normalizeTargetUrl } from '../browser/target-url';

/**
 * Which of the extension's ways in this is, from where it is headed. Kinds
 * only: the target's own URL is the user's product and stays out.
 *
 * `target` splits `/browse`, because a local page cannot be walked by the
 * hosted browser and waits on the extension to capture it by hand — the two
 * halves of that path are different funnels.
 */
export function entryOf(redirect: string): {
  entry: string;
  target?: string;
} {
  const url = new URL(redirect, window.location.origin);
  if (url.pathname === '/rooms/from-audit') return { entry: 'extension_audit' };
  if (url.pathname === '/browse') {
    const target = normalizeTargetUrl(url.searchParams.get('url') ?? '');
    return {
      entry: 'extension_browse',
      target: !target ? 'invalid' : isLocalTarget(target) ? 'local' : 'public',
    };
  }
  return { entry: 'extension_other' };
}
